import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import {
  createContext,
  FunctionComponent,
  ReactElement,
  // useContext,
  useMemo,
} from "react";
// import { GetUserProfileContext } from "../UserProfile";

export const OngoingBulkTransactionsContext = createContext(null);

type Props = {
  children: ReactElement;
};

const OngoingBulkTransactionsProvider: FunctionComponent<Props> = ({
  children,
}) => {
  // const { data: userData } = useContext(GetUserProfileContext);

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["ongoing_bulk_transaction_list"],
    // refetchInterval: 5 * 60 * 1000,
    // staleTime: 0,
    // enabled: userData && userData?.organisation?.has_bulk_process_running,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/transactions/upload/list`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [data, isLoading, isFetching],
  );
  return (
    <OngoingBulkTransactionsContext.Provider value={contextValue}>
      {children}
    </OngoingBulkTransactionsContext.Provider>
  );
};

export default OngoingBulkTransactionsProvider;
